export default {
  name: process.env.VUE_APP_NAME,
  version: require('../../package.json').version
}
